import React from 'react'
import { Nav, NavItem, } from 'reactstrap'
import PropTypes from 'prop-types'

const ProgramTypeTile = ({ 
  programType = '', 
  selected    = false, 
  text        = '',
  hover       = '',
  isMobileDisplay = false,
}) => <>
  <button type={isMobileDisplay ? 'submit' : 'button'} className={'invis-button'}>
    <div className={'search-category-text full-size align-top'} title={`${hover}`}>
      <span className={`program-type-${programType}-text prg-cat-container ${(selected) ? 'category-selected' : ''}`}>{text}</span>
      { selected && <div className={'search-selected-indicator'}></div> }
    </div>
  </button>
</>

ProgramTypeTile.propTypes = {
  programType     : PropTypes.string,
  selected        : PropTypes.bool,
  text            : PropTypes.string,
  isMobileDisplay : PropTypes.bool,
  hover           : PropTypes.string,
}

const noop = () => {}

const ProgramSearchCategories = ({
  types,
  activeType = '',
  setType    = noop,
  isMobileDisplay,
}) => {
  return <Nav className={'search-category-tabs px-2 mt-2'}>
    {
      types.map((type, idx) => {
        return <NavItem className={''} onClick={() => setType(type.name)} key={`pgm-cat-${idx}`}>
          <ProgramTypeTile
            programType={type.name}
            text={type.text}
            hover={type.description}
            selected={activeType === type.name}
            isMobileDisplay={isMobileDisplay}
          />
        </NavItem>
      })
    }
  </Nav>
}

ProgramSearchCategories.propTypes = {
  types           : PropTypes.array,
  activeType      : PropTypes.string,
  setType         : PropTypes.func,
  isMobileDisplay : PropTypes.bool,
}

export default React.memo(ProgramSearchCategories)